import { Injectable, inject } from "@angular/core";
import { GtmTrackerService } from "./gtm-tracker.service";

@Injectable({ providedIn: "root" })
export class GtmLoaderService {
  private loaded = false;
  private readonly instantiate = inject(GtmTrackerService);

  load(tagId: string) {
    if (this.loaded) return;
    this.loaded = true;

    const script = document.createElement("script");
    script.id = "gtm-script";
    script.nonce = "hY7p2Qw8XzMv3K9B";
    script.src = `https://www.googletagmanager.com/gtm.js?id=${tagId}`;
    script.async = true;

    document.head.appendChild(script);

    // create dataLayer if missing
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      "gtm.start": Date.now(),
      event: "gtm.js",
    });

  }
}
